"use strict";

var _slicedToArray = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _taggedTemplateLiteral = require("/home/dev56/soham/..................../auto-dl-admin-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");
var _templateObject, _templateObject2;
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
var _Radio = require("@mui/material/Radio");
var _Radio2 = _interopRequireDefault(_Radio);
var _QuestionContainer = require("../QuestionContainer");
var _QuestionContainer2 = _interopRequireDefault(_QuestionContainer);
var _styledComponents = require("styled-components");
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _QuestionText = require("../QuestionText");
var _QuestionText2 = _interopRequireDefault(_QuestionText);
var _AsyncDropdown = require("../AsyncDropdown");
var _AsyncDropdown2 = _interopRequireDefault(_AsyncDropdown);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Row = _styledComponents2.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var AnswerContainer = _styledComponents2.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"])));
var APIAutocompleteQuestion = function APIAutocompleteQuestion(_ref) {
  var question = _ref.question,
    onChangeAnswer = _ref.onChangeAnswer,
    autocompleteRequest = _ref.autocompleteRequest;
  var _ref2 = (0, _react.useState)(question.defaultAnswer || undefined),
    _ref3 = _slicedToArray(_ref2, 2),
    answer = _ref3[0],
    changeAnswer = _ref3[1];
  return _react2.default.createElement(_QuestionContainer2.default, {
    question: question,
    answered: answer !== undefined
  }, _react2.default.createElement(_AsyncDropdown2.default, {
    id: question.id ? question.id : "",
    answer: answer,
    placeholder: question.placeholder,
    requestUrl: question.requestUrl,
    autocompleteRequest: autocompleteRequest,
    onChange: onChangeAnswer
  }));
};
exports.default = APIAutocompleteQuestion;